import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
// import { DropdownButton, Dropdown } from "react-bootstrap";
import api from "services/api";
import { Link } from "react-router-dom";

// components
import ProfileDetails from "elements/dashboard_elements/ProfileDetails";
import Cashier from "elements/dashboard_elements/Cashier";
import AccountActvity from "elements/dashboard_elements/AccountActvity";
import TransactionHistory from "elements/dashboard_elements/TransactionHistory";
import GamingHistory from "elements/dashboard_elements/GamingHistory";
import FreeSpins from "elements/dashboard_elements/FreeSpins";
import Notifications from "elements/dashboard_elements/Notifications";
import Messages from "elements/dashboard_elements/Messages";
import AccessControl from "elements/dashboard_elements/AccessControl";
import FavoriteGames from "elements/dashboard_elements/FavoriteGames";
import Verify from "elements/dashboard_elements/Verify";
import ReferAndEarn from "elements/dashboard_elements/ReferAndEarn";
import Withdraw from "elements/dashboard_elements/Withdraw";
import { __ } from "services/Translator";
import { Tabs, Tab } from "react-bootstrap";

export default function UserDashboard(props) {
  const params = useParams();
  const history = useHistory();
  // const tab = params.tab;
  const [activeTab, setActiveTab] = useState("account-details");
  const [activeTabName, setActiveTabName] = useState("Account Details");

  const [animationStarts, setAnimationStarts] = useState(false);
  const closeDetails = () => {
    props.setShowLeftSidebar(true);
    setTimeout(function () {
      props.setShowLeftSidebar(false);
    }, 500);

    history.push("/games/all");
  };

  useEffect(() => {
    setActiveTab(params.tab);
    // alert(params.tab);
    if (params.tab === "account-details") {
      setActiveTabName("Account Details");
    } else if (params.tab === "cashier") {
      setActiveTabName("Cashier");
    } else if (params.tab === "transaction-history") {
      setActiveTabName("Transaction History");
    } else if (params.tab === "gaming-history") {
      setActiveTabName("Gaming History");
    } else if (params.tab === "free-spins") {
      setActiveTabName("Free Spins");
    } else if (params.tab === "fortunes") {
      setActiveTabName("Fortunes");
    } else if (params.tab === "notifications") {
      setActiveTabName("Notifications");
    } else if (params.tab === "messages") {
      setActiveTabName("Messages");
    } else if (params.tab === "responsible-gaming") {
      setActiveTabName("Responsible Gaming");
    } else if (params.tab === "account-activity") {
      setActiveTabName("Account Activity");
    } else if (params.tab === "my-games") {
      setActiveTabName("My Games");
      setKey("my-games");
    } else if (params.tab === "verify") {
      setActiveTabName("verify");
    } else if (params.tab === "withdraw") {
      setActiveTabName("withdraw");
    }
  }, [params.tab]);

  //Verify id checking

  const [level2submitted, setLevel2submitted] = useState(false);
  const [level2Verification, setLevel2Verification] = useState(false);

  const [level3submitted, setLevel3submitted] = useState(false);
  const [level3Verification, setLevel3Verification] = useState(false);

  const [level4submitted, setLevel4submitted] = useState(false);
  const [level4Verification, setLevel4Verification] = useState(false);

  const getIdUploads = async () => {
    var response = await api.get("/id-uploads");
    // console.log("id-uploadsid-uploads", response);
    if (response.status === 200 && response.data) {
      if (response.data.poif && response.data.poib) {
        if (
          response.data.poif.approved == "approved" &&
          response.data.poib.approved == "approved"
        ) {
          setLevel2Verification(true);
        } else if (
          response.data.poif.approved == "submitted" &&
          response.data.poib.approved == "submitted"
        ) {
          setLevel2submitted(true);
        }
      }

      if (response.data.poa) {
        if (response.data.poa.approved == "approved") {
          setLevel3Verification(true);
        } else if (response.data.poa.approved == "submitted") {
          setLevel3submitted(true);
        }
      }
      if (response.data.sof) {
        if (response.data.sof.approved == "approved") {
          setLevel4Verification(true);
        } else if (response.data.sof.approved == "submitted") {
          setLevel4submitted(true);
        }
      }
    }
  };

  useEffect(() => {
    if (props.isAuthenticated) {
      getIdUploads();
    }
  }, []);

  const [showMainNotification, setShowMainNotification] = useState(false);
  useEffect(() => {
    if (
      props.freeSpinCount > 0 ||
      props.notifictionCount > 0 ||
      props.messageCount ||
      !level2submitted ||
      !level3submitted
    ) {
      setShowMainNotification(true);
    } else {
      setShowMainNotification(false);
    }
  }, [props]);

  //Custom action for Tabs
  const [key, setKey] = useState("account-details");

  const handleSelect = (k) => {
    // console.log(`Selected tab: ${k}`);
    // Add your custom action here
    customAction(k);
    setKey(k);
  };

  const customAction = (selectedKey) => {
    switch (selectedKey) {
      case "account-details":
        // console.log("Home tab selected");
        // Add any custom logic for the Home tab here
        break;
      case "verify":
        // console.log("Profile tab selected");
        // Add any custom logic for the Profile tab here
        break;
      case "TransactionHistory":
        // console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;

      case "AccountActivity":
        // console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "GamingHistory":
        // console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "ResponsibleGaming":
        // console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      default:
        break;
    }
  };

  //Edit Account Action
  const [editAccountAction, setEditAccountAction] = useState(false);

  const handleDataFromProfileDetails = (childData) => {
    setEditAccountAction(childData);
    if (childData == true) {
      setKey("verify");
    }
  };

  return (
    <div className="user_dashboard ">
      <div className="container-lg">
        <div className="row">
          <div className="col-12 ">
            <div className="dashboard_content">
              <div onClick={closeDetails} className="close_icon">
                <svg
                  width="28"
                  height="28"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <title>close</title>
                  <path d="M18.984 6.422L13.406 12l5.578 5.578-1.406 1.406L12 13.406l-5.578 5.578-1.406-1.406L10.594 12 5.016 6.422l1.406-1.406L12 10.594l5.578-5.578z"></path>
                </svg>
              </div>
              {[
                "account-details",
                "verify",
                "TransactionHistory",
                "AccountActivity",
                "GamingHistory",
                "ResponsibleGaming",
                "my-games",
              ].includes(activeTab) && (
                <div className="account_tabs">
                  <Tabs
                    // defaultActiveKey={activeTab}
                    // defaultActiveKey="account-details"
                    id="uncontrolled-tab-example"
                    className=""
                    activeKey={key}
                    onSelect={handleSelect}
                  >
                    <Tab
                      eventKey="account-details"
                      className={" slideUpAnimation "}
                      title="Account"
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      <ProfileDetails
                        sendDataToParent={handleDataFromProfileDetails}
                        {...props}
                      />
                    </Tab>
                    <Tab
                      eventKey="verify"
                      className={" slideUpAnimation "}
                      title={
                        ((!level2submitted || !level3submitted) && (
                          <>
                            {"Verify "}{" "}
                            <div className="notification_round"></div>
                          </>
                        )) ||
                        ((level2submitted || level3submitted) && (
                          <>
                            {"Verify "}{" "}
                            <div className="notification_round orenge"></div>
                          </>
                        ))
                      }
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      {(!level2submitted || !level3submitted) && (
                        <div className="notification_round"></div>
                      )}

                      {level2submitted && level3submitted && (
                        <div className="notification_round orenge"></div>
                      )}
                      <Verify {...props} />
                    </Tab>
                    <Tab
                      eventKey="TransactionHistory"
                      className={" slideUpAnimation "}
                      title="Transaction History"
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      <TransactionHistory {...props} />
                    </Tab>
                    <Tab
                      eventKey="AccountActivity"
                      className={" slideUpAnimation "}
                      title="Account Activity"
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      <AccountActvity {...props} />
                    </Tab>
                    <Tab
                      eventKey="GamingHistory"
                      className={" slideUpAnimation "}
                      title="Gaming History"
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      <GamingHistory {...props} />
                    </Tab>
                    <Tab
                      eventKey="ResponsibleGaming"
                      className={" slideUpAnimation "}
                      title="Responsible Gaming"
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      <AccessControl {...props} />
                    </Tab>
                    <Tab
                      eventKey="my-games"
                      className={" slideUpAnimation "}
                      title="My Games"
                      onClick={() => {
                        setAnimationStarts(true);
                        setTimeout(function () {
                          setAnimationStarts(false);
                        }, 3000);
                      }}
                    >
                      <FavoriteGames {...props} />
                    </Tab>
                  </Tabs>
                </div>
              )}
              {/* {activeTab === "account-details" && <ProfileDetails {...props} />} */}
              {activeTab === "cashier" && <Cashier {...props} />}
              {/* {activeTab === "account-activity" && (
                <AccountActvity {...props} />
              )} */}
              {/* {activeTab === "transaction-history" && (
                <TransactionHistory {...props} />
              )} */}
              {activeTab === "free-spins" && <FreeSpins {...props} />}{" "}
              {activeTab === "notifications" && <Notifications {...props} />}
              {activeTab === "messages" && <Messages {...props} />}
              {/* {activeTab === "responsible-gaming" && (
                <AccessControl {...props} />
              )} */}
              {/* {activeTab === "gaming-history" && <GamingHistory {...props} />} */}
              {/* {activeTab === "my-games" && <FavoriteGames {...props} />} */}
              {/* {activeTab === "verify" && <Verify {...props} />} */}
              {activeTab === "refer-and-earn" && <ReferAndEarn {...props} />}
              {activeTab === "withdraw" && <Withdraw {...props} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
